import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Icon from "components/icon";
import IconButton from "components/icon-button";
import DialogDeleteOcurrenceSource from './dialog-delete-ocurrence-source';

const useStyles = makeStyles({
  table: {
    minWidth: 350,
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  }
});


export default function OcurrenceSourcesPaginatedTable({intl,  items, contractId, eventType, handleGetOcurrenceSource}) {
  const [open, setOpen] = useState(false);
  const [itemSelected, setItemSelected] = useState(null);

  const classes = useStyles();
  
  const handleClickOpen = (item) => {
    setItemSelected(item);
    setOpen(true);
  };

  const handleClose = () => {
    handleGetOcurrenceSource();
    setOpen(false);
  };
 
  return (
<>
    <TableContainer component={Paper}>
      {items && <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>{intl.formatMessage({ id: "event.matchPointConfig.ocurrencesSource" })}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((row) => (
            <TableRow key={row}>
              <TableCell component="th" scope="row">
              <div className={classes.row}>
                <div>
                {row}
               </div>
              <div>
                <IconButton onClick={() => handleClickOpen(row)}>
                  <Icon name="delete"/>
                </IconButton>
              </div>
                </div>
              </TableCell>
            </TableRow>
          ))}
          <DialogDeleteOcurrenceSource eventType={eventType} open={open} handleClose={handleClose}
                                       item={itemSelected} intl={intl}
                                       contractId={contractId} />
        </TableBody>
      </Table>}
    </TableContainer>
</>
  );
}